import React from 'react';
import {
  Card, CardHeader, CardTitle, CardMeta, EmptyState, Skeleton,
} from '../styles';

// Ortak kart çerçevesi (başlık + sağ meta + yükleme iskeleti + boş durum) —
// performance-dashboard/components/DashboardCard.js (Task 32) ile aynı desen
// (bağımsız kopya, repo konvansiyonu).
export default function DashboardCard({
  title, meta, span, spanMd, loading, empty, emptyText, children,
}) {
  return (
    <Card $span={span} $spanMd={spanMd}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {meta ? <CardMeta>{meta}</CardMeta> : null}
      </CardHeader>
      {loading ? <Skeleton /> : empty ? <EmptyState>{emptyText}</EmptyState> : children}
    </Card>
  );
}
